import { createApp } from 'vue';
import App from './App.vue'
import PrimeVue from 'primevue/config'; // PrimeVue
import 'primeicons/primeicons.css' // Icons css
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import BadgeDirective from 'primevue/badgedirective';
import '/node_modules/primeflex/primeflex.css' // PrimeFlex
import 'material-icons/iconfont/material-icons.css'; // Material icons
import '@/assets/theme-main.css' // Main CSS
import router from './router'; // Router
import store from './store'; // Store
import Tooltip from 'primevue/tooltip'; // Tooltips

// Create the application
const app = createApp(App);

// Setup the application
app.directive('tooltip', Tooltip);
app.directive('badge', BadgeDirective);
app.use(router)
app.use(PrimeVue);
app.use(ConfirmationService);
app.use(ToastService);
app.provide('toastService', ToastService);
app.use(store);

// Mount the application
app.mount('#app')
